<template>
    <section>
        <el-card shadow="never">
            <div class="top-bar">
                <el-button  class="top-btn" type="success" plain @click="handleShow()"  >添加</el-button >
                <el-button  class="top-btn" type="danger"  plain @click="handleBatch">删除</el-button >
            </div>
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无分类" max-height="540"  style="width:100%;">
                <el-table-column type="selection"   align="center"> </el-table-column>
                <el-table-column  label="图片" align="center" v-if="section != 4">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.pic_url" :src="scope.row.pic_url" :width="section != 5 ? 160 : 343" :height="section != 5 ? 160 : 182" />
                    </template>
                </el-table-column>
                <el-table-column prop="title"      label="名称"    align="center"  ></el-table-column>
                <el-table-column prop="title_en"   label="英文名称"    align="center" ></el-table-column>
                <el-table-column prop="off"   label="折扣"    align="center" v-if="section == 5"></el-table-column>
                <el-table-column prop="row_pro_num"    label="商品样式"  align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.row_pro_num == 1">一行一列</span>
                        <span v-if="scope.row.row_pro_num == 2">一行两列</span>
                        <span v-if="scope.row.row_pro_num == 3">一行三列</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sort"    label="排序"    align="center" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.sort" @change="handleSort(scope.row)" size="mini" ></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="特别标注" align="center" v-if="section == 7">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.tagging == 0" type="primary" plain size="mini"  @click="handleTag(scope.row)">标注分类</el-button>
                        <el-button v-else type="success" plain size="mini"  @click="handleTag(scope.row)">取消标注</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="status"    label="状态"    align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
             <!-- <el-pagination background layout="prev, pager, next, jumper"  style="padding:10px" :total="total" :page-size="size"  @current-change="loadMore"></el-pagination> -->
        </el-card>
        


        <!-- 分类编辑弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item" >
                <el-col :span="4" class="input-left" >
                    <p>中文名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="name" placeholder="请输入中文分类名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item" >
                <el-col :span="4" class="input-left">
                    <p>英文名称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="engname" placeholder="请输入英文分类名称"></el-input>
                </el-col>
            </el-row>
            <el-row class="m-bottom-4" v-if="section != 4">
                <el-col :span="4" class="input-left">
                    分类图标：
                </el-col>
                <el-col :span="18" style="display:flex;">
                    <m-upload :img.sync="image"  :width="section != 5 ? 100 : 343" :height="section != 5 ? 100 : 182" file-name="ThemeClass"  placement="right" />
                    <div class="suggest-size">
                        {{this.place_holder}}
                    </div>
                </el-col>
            </el-row>
            <el-row class="line-item" v-if="section == 5">
                <el-col :span="4" class="input-left">
                    <p>分类折扣：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="off" placeholder="例：9折输入90"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>分类排序：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="sort" placeholder="请输入排序(正序排列)"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>商品样式：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="row_pro_num" :label="1" border>一行一列</el-radio>
                    <el-radio v-model="row_pro_num" :label="2" border>一行两列</el-radio>
                    <el-radio v-model="row_pro_num" :label="3" border>一行三列</el-radio>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { classify_list, classify_add, classify_put, classify_del } from '@/api/market.js'
import MUpload from '@/components/m-upload.vue'
import MImg   from '@/components/Image'
export default {
    props: [ 'section', 'classify', 'place_holder' ],
    components:{ MUpload, MImg },
    data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            size: 20,
            ids:[],          // table 选中数据的 id 数组集合
            dialog:false,    // 控制显示 添加修改弹窗
            dialogTitle:'添加分类',
            id:'',           //  有id 是修改  没有id是添加
            name:'',
            engname: '',
            off: '',
            sort:1,
            row_pro_num: 1,
            image: { url: '', pic_id: '' },   // 主图

        }
    },
    methods: {
        // 获取分类数据
         handleData() {
            let params = {
                cid: this.section,
            // page: this.page,
            }
            if(this.value != '' ) {
                params.name = this.value
            }
            classify_list(params).then(res => {
                if(res) {
                    this.tableData = res.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                    this.$emit('update:classify', res.data.data)
                }else {
                    this.tableData = []
                }
            })
        },
        loadMore(page) {
            this.page = page
            this.handleData()
        },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                this.dialog      = true
                this.dialogTitle = '修改分类'
                this.id          = row.id
                this.name        = row.title
                this.engname     = row.title_en
                this.off         = row.off
                this.row_pro_num         = row.row_pro_num
                this.sort        = row.sort
                if(row.pic_url && row.pic_url) {
                    this.image =  {
                        url:row.pic_url,
                        pic_id:row.pic_id
                    }
                }else {
                    this.image       =  { url: '', pic_id: '' }
                }
            }else{
                this.dialog      = true
                this.dialogTitle = '添加分类'
                this.id          = ''
                this.name        = ''
                this.engname     = ''
                this.sort        = 1
                this.off         = ''
                this.row_pro_num         = 1
                this.image       =  { url: '', pic_id: '' }
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加分类函数
        handleAdd(){
            let params = {
                cid: this.section,
                title:this.name,
                title_en:this.engname,
                sort:this.sort,
                row_pro_num: this.row_pro_num
            }
            if(this.section == 5) {
                params.off = this.off
            }
            if(this.image.pic_id != '') {
                params.pic_id = this.image.pic_id
            }
            classify_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改分类函数
        handlePut(){
            let params = {
                title:this.name,
                title_en:this.engname,
                sort:this.sort,
                row_pro_num: this.row_pro_num
            }
            if(this.section == 5) {
                params.off = this.off
            }
            if(this.image.pic_id != '') {
                params.pic_id = this.image.pic_id
            }
            classify_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // // 修改排序
        handleSort(row){
            let params = {
                sort:row.sort
            }
            classify_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改状态
        handleStatus(row){
             let params = {
                status:row.status
            }
            classify_put(row.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        //  // 点击删除 
        handleDel(item){
            console.log(item)
            this.$confirm(`此操作将删除分类： ${item.title}， 是否继续?`, '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                classify_del(item.id).then(res => {
                    this.$message({type:"success",message:res.msg})
                    this.handleData();
                })
            })
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        // 批量删除
        handleBatch(){
            if(this.ids.length == 0){
                this.$message({type:'error',message:'请至少选中一条数据进行批量操作哦',})
                return false;
            }
            this.$confirm(`此操作将删除所有选中的分类, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                classify_del(this.ids).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            })
        },
        // 特别标注分类
        handleTag(row) {
            let params = {
                tagging: row.tagging == 0 ? 1 : 0
            }
            classify_put(row.id,params).then(res => {
                if(res) {
                    this.handleData()
                    this.$message({type:'success',message:res.msg})
                }
            })
        },
    },
    created(){
        this.handleData();
    },
    activated() {
        // this.getData()
    },
}
</script>

<style lang="less" scoped>
section{
    .top-btn {
        width: 80px;
        margin-right: 15px;
    }
    .line-item {
        margin-bottom: 20px;
    }
    .input-left {
        height: 40px;
        line-height: 40px;
    }
    /deep/  .el-input--mini .el-input__inner  {
        text-align: center;
        width: 60px;
    } 
    .suggest-size {
        line-height: 182px;
        color: grey;
        font-size: 0.9em;
    }
}
</style>